import React, { Component } from "react";
import FlexView from "react-flexview";
import { configLast3Years, transformResponseLastThreeYearsToTable, yearOptions } from "../config";
import * as R from "ramda";
import { removeNullFields } from "../../../../common/mapper";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleUploadImage from "../../../../../modules/upload/SimpleUploadImage";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import { service } from "./service";
import CardBiaxialChart from "../../../../../cards/BiaxialChart";

class LastThreeYearsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: null,
      tableConfig: [],
      dataTable: [],
      chartVisible: false,
      chartUrl: "",
    };
  }

  componentDidMount() {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
      tableConfig: [
        { name: "name", label: "Nama Sales/\nCS", options: { sort: false } },
        ...configLast3Years(),
      ],
    }));
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!R.equals(prevProps.search, this.props.search)) {
      this.fetchData();
    }
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleChartVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      chartVisible: !prevValue.chartVisible,
    }));
  };

  fetchData = async () => {
    this.props.triggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanJualan3TahunTerakhir,
      setError: this.props.setError,
      menuName:
        "Dashboard Level Kepala Cabang By Sales - Laporan Jualan 3 Tahun Terakhir",
      args: {
        kodeCabang: [this.props.kodeCabang?.value],
        year: this.state.year?.value,
        mode: "SALESMAN",
        idLeader: this.props.idLeader,
        idSalesman: null,
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: transformResponseLastThreeYearsToTable(res.data.data),
      }));
    }
    this.props.triggerLoading();
  };

  handleSearch = () => {
    this.setState(
      (prev) => ({
        ...prev,
        tableConfig: [
          { name: "name", label: "Nama Sales/\nCS", options: { sort: false } },
          ...configLast3Years(prev.year?.value),
        ],
      }),
      () => this.fetchData(),
    );
  };

  render() {
    const { data, dataKey } = service.transformChartData(this.state.dataTable, this.state.tableConfig);
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            isClearable
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={()=> this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        {!this.state.chartVisible && (
          <SimpleDataTable
            data={this.state.dataTable}
            columns={this.state.tableConfig}
          />
        )}
        {this.state.chartVisible && (
          <CardBiaxialChart data={data} dataKey={dataKey} />
        )}
        <FlexView style={{ justifyContent: "end", marginTop: "15px" }}>
          <SimpleButton onClick={this.handleChartVisibility}>
            Chart
          </SimpleButton>
        </FlexView>
      </>
    );
  }
}

export default LastThreeYearsReport;